/**
 * Breathe: Guided Breathwork & Meditation
 *
 * Declares a single web-accessible-resource entry, matched to `<all_urls>` with
 * an explicit `use_dynamic_url: false`, exposing three static HTML files:
 * `src/dashboard/index.html`, `src/sidepanel/index.html` and
 * `src/offscreen/offscreen.html`. Each is fetchable from any page at a fixed
 * URL — served only if the extension is installed, with the ID in the URL.
 *
 * Manifest verified against version 4.0.4.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'andfohanhajengikbobaoblbdkmlkicp';

export const breathe: ExtensionDefinition = {
  id: ID,
  name: 'Breathe: Guided Breathwork & Meditation',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 6_000,
  notes:
    'Three static HTML WAR on <all_urls> with use_dynamic_url explicitly false. ' +
    'Detection is a single fetch and conclusive.',
  signals: [
    {
      id: 'war-dashboard-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch src/dashboard/index.html — a static entry point exposed to every origin ' +
        'at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'src/dashboard/index.html'),
    },
    {
      id: 'war-sidepanel-html',
      kind: 'web-accessible-resource',
      description: 'Fetch src/sidepanel/index.html — a second static path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'src/sidepanel/index.html'),
    },
    {
      id: 'war-offscreen-html',
      kind: 'web-accessible-resource',
      description: 'Fetch src/offscreen/offscreen.html — a third static path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'src/offscreen/offscreen.html'),
    },
  ],
};
